// src/services/influencerSearchService.js
import { apiRequest } from "./apiService";

const buildQueryString = (params) => {
  const entries = Object.entries(params).filter(([, v]) => v !== undefined && v !== null && v !== "");
  if (!entries.length) return "";
  const query = entries
    .map(([k, v]) => `${encodeURIComponent(k)}=${encodeURIComponent(String(v))}`)
    .join("&");
  return `?${query}`;
};

export const searchInfluencers = async ({
  platform,
  city,
  niche,
  tags,
  tagMode = "any",
  minFollowers,
  minMediaCount,
  minEngagementRate,
  onlyActive = true,
  minGeoConfidence,
  sort,
  seed,
  excludeSeen,
  limit = 50,
  lastKey,
}) => {
  const qs = buildQueryString({
    platform,
    city,
    niche,
    tags,
    tag_mode: tagMode,
    min_followers: minFollowers,
    min_media_count: minMediaCount,
    min_engagement_rate: minEngagementRate,
    only_active: onlyActive != null ? String(Boolean(onlyActive)) : undefined,
    min_geo_confidence: minGeoConfidence || undefined,
    sort: sort || undefined,
    seed: seed || undefined,
    exclude_seen: excludeSeen != null ? String(Boolean(excludeSeen)) : undefined,
    limit,
    last_key: lastKey ? JSON.stringify(lastKey) : undefined,
  });

  return apiRequest(`/influencers/search${qs}`, "GET");
};

export const getInfluencerDetails = async (influencerId) =>
  apiRequest(`/influencer/${encodeURIComponent(influencerId)}`, "GET");

export const enrichInstagram = async (payload) => apiRequest("/instagram/enrich", "POST", payload);
export const enrichYoutube = async (payload) => apiRequest("/youtube/enrich", "POST", payload);
export const importManualCandidates = async (payload) =>
  apiRequest("/admin/candidates/import", "POST", payload);


export const clearSeenInfluencers = async ({ platform, city, niche, sort, seed }) => {
  const qs = buildQueryString({ platform, city, niche, sort: sort || undefined, seed: seed || undefined });
  return apiRequest(`/influencers/seen${qs}`, "DELETE");
};
